import { createFeatureFlag } from "../functions/featureFlags";
import { getShopUrl } from "shared-frontend/functions/products";

// Black Friday 2026 campaign dates
// Start: November 26, 2026 at 11:15 AM CET (10:15 UTC)
// (The sale starts at 11:00 AM CET, but the banners should be displayed 15 minutes later to avoid showing them before the sale starts)
// End: December 1, 2026 at 11:00 AM CET (10:00 UTC)
export const BLACK_FRIDAY_START = new Date( "2026-11-26T10:15Z" );
export const BLACK_FRIDAY_END = new Date( "2026-12-01T10:00Z" );

/**
 * Determines if Black Friday banners should be displayed.
 *
 * Enable via:
 * - Environment variable: REACT_APP_ENABLE_BF_BANNER=true
 * - Query param: ?test_bf_banner (persists for browser session)
 * - Date range: automatically enabled during the Black Friday period
 *
 * @returns {boolean} True if Black Friday banners should be displayed.
 */
export const isBlackFridayActive = createFeatureFlag( "bf_banner", () => {
	const now = new Date();

	return now >= BLACK_FRIDAY_START && now <= BLACK_FRIDAY_END;
} );

// Shop URL for Black Friday CTAs
export const BLACK_FRIDAY_SHOP_URL = getShopUrl() + "/shop/";
